import {
  ClipboardIcon,
  Cog8ToothIcon,
  HomeIcon,
  UserIcon,
  BookmarkIcon,
  MicrophoneIcon,
  BookOpenIcon,
  QuestionMarkCircleIcon,
  GiftIcon,
} from '@heroicons/react/24/outline';
import { ItemType, MenuItemType } from 'antd/es/menu/interface';
import { Link } from 'react-router-dom';

const SidebarTodoItem = (subType: string) => {
  if (subType === 'home') {
    return [
      {
        label: (
          <Link to={`./todo-management/jebs_ai_recitation`}>AI 인증제</Link>
        ),
        key: 'jebs_ai_recitation',
      },
      {
        label: <Link to={`./todo-management/jebson`}>젭스온</Link>,
        key: 'jebson',
      },
    ];
  } else if (subType === 'church') {
    return [
      {
        label: <Link to={`./todo-management/jebspl`}>젭스플</Link>,
        key: 'jebspl',
      },
    ];
  } else {
    return undefined;
  }
};

const SidebarTodoList = (subType: string) => {
  if (subType === '') return [];

  const result: ItemType<MenuItemType>[] = [
    {
      label: '할 일 관리',
      key: 'todo',
      icon: <ClipboardIcon className="h-6 w-6" />,
      children: SidebarTodoItem(subType),
    },
  ];

  if (subType === 'home') {
    result.push({
      label: '인증제 내역',
      key: 'recitation-history',
      icon: <MicrophoneIcon className="h-6 w-6" />,
      children: [
        // {
        //   label: <Link to={`./recitation/dashboard`}>대쉬보드</Link>,
        //   key: 'recitation-dashboard',
        // },
        {
          label: <Link to={`./recitation/list`}>현황 목록</Link>,
          key: 'recitation-list',
        },
      ],
    });
  }
  return result;
};

/**
 * 사이드 메뉴 리스트
 * @param menuExposure 현재 코스의 분류
 * @returns 사이드 메뉴 리스트
 */
export const SidebarItems = (menuExposure: 'home' | 'church' | '') => [
  {
    label: <Link to={`./dashboard`}>클래스 메인</Link>,
    key: 'dashboard',
    icon: <HomeIcon className="h-6 w-6" />,
  },
  {
    label: <Link to={`./take-class`}>수업하기</Link>,
    key: 'take-class',
    icon: <BookOpenIcon className="h-6 w-6" />,
  },
  // {
  //   label: '수업 관리',
  //   key: 'management',
  //   icon: <ClipboardIcon className="h-6 w-6" />,
  //   children: [
  //     {
  //       label: <Link to={`./course-management`}>코스관리</Link>,
  //       key: 'course-management',
  //     },
  //     {
  //       label: <Link to={`./take-class`}>수업하기</Link>,
  //       key: 'take-class',
  //     },
  //   ],
  // },
  ...SidebarTodoList(menuExposure), // 코스 분류 별 할 일 관리 리스트 (홈스쿨 베이직 / 교회학교 HFHJ, WMW / 그 외)
  {
    label: <Link to={`./signup-management`}>학생 관리</Link>,
    key: 'signup-management',
    icon: <UserIcon className="h-6 w-6" />,
    // children: [
    //   {
    //     label: <Link to={`./signup-management`}>학생 관리</Link>,
    //     key: 'signup-management',
    //   },
    //   {
    //     label: <Link to={`./migration`}>구버전 학생 가져오기</Link>,
    //     key: 'migration',
    //   },
    // ],
  },
  {
    label: <Link to={`./reference-room`}>자료실</Link>,
    key: 'reference-room',
    icon: <BookmarkIcon className="h-6 w-6" />,
  },
  {
    label: <Link to={`./event`}>이벤트</Link>,
    key: 'event',
    icon: <GiftIcon className="h-6 w-6" />,
  },
  {
    label: <Link to={`./dashboard`}>LMS 이용 가이드</Link>,
    key: 'lms-guide',
    icon: <QuestionMarkCircleIcon className="h-6 w-6" />,
    onClick: () => {
      window.open(
        'https://jebs-notice.oopy.io/efc91373-7886-423c-8a68-76ee7de7d3de',
        '_blank',
      );
    },
  },
  // {
  //   label: '클래스 설정',
  //   key: '5',
  //   icon: <Cog8ToothIcon className="h-6 w-6" />,
  //   onClick: () => {
  //     alert('준비중인 기능입니다.');
  //   },
  // },
];
